module.exports = __webpack_public_path__ + "img/icon_data_empty.16a5bc9f.png";